import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { GroupsProps } from 'services/groups/types';
import ButtonLink from 'components/ButtonLink';
import { updateQueryString } from 'services/router/actions';
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import { makeSelectGroupPeopleIds } from 'services/groupPeople/selectors';
// @ts-ignore
import { makeSelectGroupEntitiesIds } from 'services/groupEntities/selectors';
import {
    makeSelectGroupName,
    makeSelectGroupColor
} from 'services/groups/selectors';

type OwnProps = GroupsProps;

interface ConnectedProps {
    personIds?: ReturnType<ReturnType<typeof makeSelectGroupPeopleIds>>;
    entityIds?: ReturnType<ReturnType<typeof makeSelectGroupEntitiesIds>>;
    name?: ReturnType<ReturnType<typeof makeSelectGroupName>>;
    color?: ReturnType<ReturnType<typeof makeSelectGroupColor>>;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class GroupDuplicateLink extends React.PureComponent<Props> {
    handleClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ): void => {
        event.stopPropagation();
        const { name, personIds, entityIds, color } = this.props;
        this.props.updateQueryString({
            groupModal: true,
            selectedGroup: undefined,
            defaultValues: {
                name: `${name} copy`,
                personIds,
                entityIds,
                color
            }
        });
    };

    render(): React.ReactElement {
        return (
            <CurrentSeasonInProgressGate>
                <ButtonLink onClick={this.handleClick}>Duplicate</ButtonLink>
            </CurrentSeasonInProgressGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    personIds: makeSelectGroupPeopleIds(),
    entityIds: makeSelectGroupEntitiesIds(),
    name: makeSelectGroupName(),
    color: makeSelectGroupColor()
});

export default connect(mapStateToProps, { updateQueryString })(
    GroupDuplicateLink
);
